import React from 'react'
import { Disclaimer } from 'application/components/styledComponents/disclaimer'
import LinkGov from '../pages/footer/linkGov'
import NonInsuranceDisclaimer from './nonInsuranceDisclaimer'
import InsuranceDisclaimer from './insuranceDisclaimer'
import { useLocation } from 'react-router-dom'

export const NonGovdisclaimer = () => {
  const location = useLocation()
  const proposalIndex = location.pathname.lastIndexOf('/')
  const result = location.pathname.substring(proposalIndex + 1)
  const insuranceDisclaimer =
    result === 'review' || result === 'pdfview' || result.indexOf('-') > -1
  return (
    <Disclaimer>
      {insuranceDisclaimer ? (
        <InsuranceDisclaimer />
      ) : (
        <NonInsuranceDisclaimer />
      )}
      <p>
        Remuneration Services (Qld) Pty Ltd ABN 46 093 173 089 (RemServ) is part
        of the McMillan Shakespeare Limited Group (MMS Group) and collects your
        personal information from you when you submit this form to us. We
        collect this information to provide and promote our products and
        services to you, and we may be unable to do so if you do not disclose
        all or part of the information requested in this form. Your personal
        information may be disclosed to other entities in the MMS Group, our
        agents, contractors and service providers (including our web and IT
        administrators, mail houses and advisers).
      </p>
      <p>
        *RemServ’s procurement, insurance and maintenance services are optional.
        You may choose to use our services or those of another provider.
      </p>

      <p>
        RemServ collects your personal information from you when you apply for a
        product and request any information from us, and we may use this
        information to contact you about our products, services and offerings.
        To read more about how we handle your personal information, please read
        our{' '}
        <LinkGov
          nonGovLink="https://mmsg.com.au/privacy"
          govLink="https://mmsg.com.au/privacy"
          text="Privacy Statement"
          classes="text-underline"
        />
        .
      </p>
    </Disclaimer>
  )
}
